// Copyright (c) 2018 Deere & Company

import ClaimProcessInvoiceContainer from '../../../claim/dealer-invoices/components/claim-process-invoice/index';

export default {
    component: ClaimProcessInvoiceContainer,
    name: 'INVOICE_REQUEST',
    path: 'claim-process-invoice/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/invoice-details/claim-process-invoice.js